import React from 'react';
import { ShieldCheck, Zap, Activity } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const CriticalCarePage = () => {
  const config = {
    badge: "24/7 Emergency Unit",
    headline: "24/7 Emergency",
    headlineItalic: "Support.",
    subtext: "Our critical care unit is available 24/7 for immediate response, diagnostic assessment, and emergency surgery for your pets.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Emergency Critical Care at Dr. Suresh Pet Care — 24/7 Veterinary Emergency",
    stats: [
      { value: 5000, suffix: '+', label: 'Emergency Cases' },
      { value: 97, suffix: '%', label: 'Stabilization Rate' },
      { value: 24, suffix: '/7', label: 'Always Open' },
      { value: 15, suffix: ' Min', prefix: '<', label: 'Average Response' },
    ],
    services: [
      {
        title: "Emergency Stabilization",
        icon: <Zap size={28} />,
        desc: "Immediate assessment and stabilization with IV access, oxygen therapy, and shock management.",
        specs: ["IV Fluid Resuscitation", "Oxygen Therapy", "Shock Protocol", "Pain Management"],
        color: "from-red-500/10 to-primary/10"
      },
      {
        title: "ICU & Monitoring",
        icon: <Activity size={28} />,
        desc: "Continuous intensive care monitoring with multi-parameter vital sign surveillance and nursing protocols.",
        specs: ["Continuous ECG", "SpO2 Monitoring", "IV Nutrition", "24-Hour Nursing"],
        color: "from-primary/10 to-orange-500/10"
      },
      {
        title: "Pet Ambulance",
        icon: <ShieldCheck size={28} />,
        desc: "Rapid-response mobile care unit with trained staff and basic life support equipment for emergency transport.",
        specs: ["Mobile Triage", "Oxygen En Route", "Rapid Transport", "Pre-Hospital Care"],
        color: "from-amber-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Emergency",
    sectionItalic: "Capabilities.",
    warningTitle: "Emergency",
    warningItalic: "Situations.",
    warningText: "These situations require immediate emergency veterinary care. Do not wait — call us on +91 9848954921 immediately.",
    warnings: [
      { name: "Difficulty Breathing", desc: "Labored breathing, gasping, or blue-tinged gums — a life-threatening emergency.", icon: "🚨" },
      { name: "Trauma / Accident", desc: "Any road accident, fall, or physical trauma requires immediate assessment.", icon: "🚗" },
      { name: "Seizures", desc: "Any seizure lasting more than 2 minutes requires emergency stabilization.", icon: "⚡" },
      { name: "Suspected Poisoning", desc: "If you suspect your pet ingested a toxic substance, call us immediately.", icon: "☠️" },
    ],
    ctaBadge: "Emergency Unit",
    ctaTitle: "24/7 Emergency",
    ctaItalic: "Response.",
    ctaText: "Our emergency team is always on standby. Call +91 9848954921 at any time of day or night for immediate veterinary emergency assistance in Hyderabad.",
    ctaBtn: "Call Emergency Now",
    seoText: "24/7 emergency veterinary care in Hyderabad. Pet ambulance and critical care stabilization at Dr. Suresh Pet Care. Emergency animal hospital Vanasthalipuram.",
    glowColor: "red-500"
  };

  return (
    <>
      <SEO 
        title="24/7 Emergency Pet Hospital in Vanasthalipuram"
        description="In case of a pet emergency, visit Dr. Suresh Pet Care Hospital. Our 24/7 critical care unit is available for immediate life-saving support for your pets in Hyderabad."
        canonical="/critical-care"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default CriticalCarePage;
